// import { extension as mimeExtension } from 'mime-types';
import * as moment from 'moment';
import { NgrxValueConverter } from 'ngrx-forms';

import { marker } from '@biesbjerg/ngx-translate-extract-marker';

import { DocumentType } from '../entities/base/document-type.enum';

export class Utils {

    static defaultValidationMessages = {
        required: marker('Campo obbligatorio'),
        pattern: marker('Formato non valido'),
        email: marker('Formato non valido'),
        maxlength: marker('Superato limite massimo di caratteri'),
        jsonSchema: marker('Formato JSON non valido'),
        jsonFormat: marker('Formato JSON non valido'),
        digit: marker('Ammessa solo una cifra'),
        requiredOneLocalizationItem: marker('Inserire almeno una lingua')
    };

    static dateValueConverter: NgrxValueConverter<moment.Moment | null, string | null> = {
        convertViewToStateValue(value) {
            if (value === null) {
                return null;
            }
            return value.toISOString();
        },
        convertStateToViewValue: (value) => {
            if (value == null) {
                return null;
            }
            return moment(value);
        },
    };

    private static getMidnightDateMoment(d: Date | string) {
        return moment(moment(d).format('YYYY-MM-DD') + 'T00:00:00Z');
    }

    static getMidnightDateUTCString(d: Date | string) {
        return Utils.getMidnightDateMoment(d).toISOString();
    }

    static getMidnightDateUTCDate(d: Date | string): Date {
        return Utils.getMidnightDateMoment(d).toDate();
    }

    public static convertBase64ToBlobData(base64Data: string, contentType?: string, sliceSize = 512) {


        if (!contentType) {
            contentType = Utils.base64MimeType(base64Data);
        }

        if (base64Data.indexOf(',') !== -1) {
            base64Data = base64Data.split(',')[1];
        }

        const byteCharacters = atob(base64Data);
        const byteArrays = [];


        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    public static base64MimeType(encodedString: string) {
        let result = null;

        if (typeof encodedString !== 'string') {
            return result;
        }

        const mime = encodedString.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);

        if (mime && mime.length) {
            result = mime[1];
        }

        return result;
    }

    public static downloadBase64File(encoded: string, name: string) {
        const blob = Utils.convertBase64ToBlobData(encoded);
        const a = document.createElement('a');
        document.body.appendChild(a);
        const fileURL = window.URL.createObjectURL(blob);
        a.href = fileURL;
        a.download = name;
        a.click();
    }

    public static sort(a: string, b: string, asc: boolean) {
        if (a === b) {
            return 0;
        }
        if (asc) {
            return a < b ? -1 : 1;
        }
        else {
            return a < b ? 1 : -1;
        }
    }

    public static groupBy(items: any[], key: string): any {
        return items.reduce((rv, item) => {
            (rv[item[key]] = rv[item[key]] || []).push(item);
            return rv;
        }, {});
    }

     static getBlobFromString(str: string, LE = false) {
        // ref: https://stackoverflow.com/q/6226189
        let charCode;
        const byteArray = [];

        if (!LE) {
            // BE BOM
            byteArray.push(254, 255);
        } else {
            // LE BOM
            byteArray.push(255, 254);
        }

        for (let i = 0; i < str.length; ++i) {
            charCode = str.charCodeAt(i);
            if (!LE) {
                // BE Bytes
                // tslint:disable-next-line:no-bitwise
                byteArray.push((charCode & 0xFF00) >>> 8);
                // tslint:disable-next-line:no-bitwise
                byteArray.push(charCode & 0xFF);
            } else {
                // LE Bytes
                // tslint:disable-next-line:no-bitwise
                byteArray.push(charCode & 0xff);
                // tslint:disable-next-line:no-bitwise
                byteArray.push(charCode / 256 >>> 0);
            }
        }

        const blob = new Blob([new Uint8Array(byteArray)], { type: 'text/csv;charset=UTF-16' + LE ? 'LE;' : 'BE;' });
        return blob;
    }
    static getBlobFromByteArray(byteArray: Uint8Array, contentType: string, LE = false) {

        const blob = new Blob([byteArray], { type: contentType  });
        return blob;
    }

    static getDocumentTypedescription(documentType: DocumentType){
        switch (documentType) {
            case DocumentType.CertificationRecord:
                return 'documenti_di_viaggio';
                break;
            case DocumentType.ClinicalRecord:
                return 'fascicolo_sanitario';
                break;
            case DocumentType.PublicHealthRecord:
                return 'igiene_pubblica';
                break;
            default:
                break;
        }
    }

    static getDocumentExtension(contentUrl: string){
        const fileName = contentUrl.substring(contentUrl.lastIndexOf('/') + 1);
        return fileName.substring(fileName.lastIndexOf('.') + 1);
    }
}


